<div class="modal-header ">
    <h4 class="modal-title header-5">
        {{ configs.title }}
    </h4>
   <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        " alt="close"
      />
    </button></div>

<div class="modal-body agent-modal">
    <div class="mb-3">
        <label class="general-text" for="execution-cycle-select">Execution Cycle</label>
        <select id="execution-cycle-select" class="form-select accello-select" [(ngModel)]="selectedExecutionCycle" (ngModelChange)="onCycleChange($event)">
            <option value="" disabled selected>Select execution cycle</option>
            <option *ngFor="let cycle of executionCycles" [value]="cycle.id">{{ cycle.name }}</option>
        </select>
    </div>
    <div class="mb-3">
        <label class="general-text" for="test-plan-select">Test Plan</label>
        <select id="test-plan-select" class="form-select accello-select" [(ngModel)]="selectedTestPlan" [disabled]="!selectedExecutionCycle">
            <option value="" disabled selected>Select test plan</option>
            <option *ngFor="let plan of availableTestPlans" [value]="plan.id">{{ plan.automationTestPlanName }}</option>
        </select>
    </div>
    <div class="mb-3">
        <span class="general-text">Status</span>
        <div class="status-cards-grid">
            <div
                class="status-card"
                [class.status-card--selected]="isStatusSelected(card.value)"
                *ngFor="let card of statusCards"
                (click)="toggleStatus(card.value)" (keydown.enter)="toggleStatus(card.value)">
                <img [src]="getStatusIcon(card)" [alt]="card.label" class="status-card__icon" />
                <span class="status-card__label general-text-2-1">{{ card.label }}</span>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <div class="w-100 d-flex justify-content-between">
        <button class=" btn-accello-tertiary" (click)="resetAll()"> Reset All </button>
        <button class=" btn-accello-primary-light" (click)="submit()" > {{ configs?.saveBtnText ? configs.saveBtnText : 'Add' }} </button>
    </div>
</div>